// hooks/useTransactionSnackbar.ts
import { useSnackbar } from "notistack";
import TransactionSnackbar from "@/components/TransactionSnackbar";

type TransactionStatus = "error" | "success" | "warning" | "info";

interface ShowTransactionSnackbarProps {
  status: TransactionStatus;
  title: string;
  message?: string;
  onTap?: () => void;
  id?: string; // Optional ID to prevent duplicate notifications
}

export function useTransactionSnackbar() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showTransactionSnackbar = ({
    status,
    title,
    message,
    onTap,
    id,
  }: ShowTransactionSnackbarProps) => {
    enqueueSnackbar("", {
      content: (key) => {
        return (
          <TransactionSnackbar
            id={id || key.toString()}
            status={status}
            title={title}
            message={message}
            closeSnackbar={closeSnackbar}
            onTap={onTap}
          />
        );
      },
    });
  };

  return { showTransactionSnackbar };
}
